import s from "./EditCourseMenu.less";
import Select from "~/shared/ui/Fields/Select";
import Input from "../Input/index";
import React from "react";
import Button from "~/shared/ui/Fields/Button";

type Props = {
  isEditCourse;
  course;
  control;
  availableCourses;
  searchText;
  intersectionObserver;
  handleOnChangeCourse;
  certificateValidityPeriod;
  courseStatusError;
  handleSaveCourse;
  handleCancelChanges;
};
const EditCourseMenu = (props: Props) => {
  const {
    isEditCourse,
    course,
    control,
    availableCourses,
    searchText,
    intersectionObserver,
    handleOnChangeCourse,
    certificateValidityPeriod,
    courseStatusError,
    handleSaveCourse,
    handleCancelChanges,
  } = props;

  return (
    <div className={s.items_edit_header}>
      <div className={s.item_edit}>
        <span className={s.label}>Курс</span>
        <Select
          name={`${course.id}course`}
          control={control}
          disabled={!isEditCourse}
          customClassName={s.select_wrapper}
          onScrollBottom={intersectionObserver}
          optionObjects={availableCourses}
          getSearchText={searchText}
          onChangeDecorator={(value) => handleOnChangeCourse(value, "course")}
          defaultValue={{ label: course.name, value: course.id }}
        />
      </div>
      <div className={s.item_edit}>
        <span className={s.label}>Срок действия сертификата</span>
        <Input
          name={`${course.id}certificateValidityPeriod`}
          disabled
          value={
            certificateValidityPeriod ? certificateValidityPeriod : "Бессрочно"
          }
          className={s.input_wrapper}
        />
      </div>
      <div className={s.item_edit}>
        <span className={s.label}>Статус</span>
        <Select
          name={`${course.id}status`}
          control={control}
          disabled={!isEditCourse}
          customClassName={s.select_wrapper}
          optionObjects={[
            { value: "active", label: "Активный" },
            { value: "inactive", label: "Неактивный" },
          ]}
          onChangeDecorator={(value) => handleOnChangeCourse(value, "status")}
          defaultValue={{
            label: course.status === "active" ? "Активный" : "Неактивный",
            value: course.status,
          }}
        />
      </div>
      {courseStatusError && (
        <span className={s.error_message}>{courseStatusError}</span>
      )}
      <div className={s.buttons}>
        <Button small={true} txtBtn={"Сохранить"} onClick={handleSaveCourse} />
        <Button
          small={true}
          txtBtn={"Отменить"}
          onClick={handleCancelChanges}
        />
      </div>
    </div>
  );
};

export default EditCourseMenu;
